"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarChartWrap = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectors = require("../../redux/selectors");
var _CalendarWithTabsWrap = require("./CalendarWithTabsWrap");
var _actions = require("../../redux/actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CalendarChartWrap = exports.CalendarChartWrap = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    chartId
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    from,
    to,
    dateType
  } = (0, _reactRedux.useSelector)((0, _selectors.selectChartParams)(chartId), (prev, next) => _paulCorePackage.functions.areEqual(prev, next));
  const updateParams = (0, _react.useCallback)(params => {
    dispatch((0, _actions.setChartParamsList)({
      chartId,
      params
    }));
  }, [dispatch, chartId]);
  return /*#__PURE__*/_react.default.createElement(_CalendarWithTabsWrap.CalendarWithTabsWrap, {
    dateType: dateType,
    from: from,
    to: to,
    setParams: updateParams
  });
});
CalendarChartWrap.propTypes = {
  chartId: _propTypes.default.string
};